import { getProjectParam } from './hooks/useProjectParams';
import { generateEmbedUrl } from './prototype-utils/prototype-utils';

export const enrichTestUrl = async (testUrl: string) => {
  const { project_uuid, is_preview, participation_uuid } = await getProjectParam([
    'project_uuid',
    'participation_uuid',
    'is_preview',
  ]);

  const url = new URL(testUrl);
  const hj_uut = window.btoa(
    `project_uuid=${project_uuid}&participation_uuid=${participation_uuid}${
      is_preview ? '&is_preview=1' : ''
    }`,
  );
  url.searchParams.append('hj_uut', hj_uut);

  return url.toString();
};

export async function getFinalUrl(testUrl: string) {
  const isPrototype = (await getProjectParam('target_site_type')) === 'prototype';
  let urlToOpen = testUrl;

  if (isPrototype) {
    urlToOpen = generateEmbedUrl(testUrl);
    const url = new URL(urlToOpen);
    const { project_uuid, is_preview, participation_uuid } = await getProjectParam([
      'project_uuid',
      'participation_uuid',
      'is_preview',
    ]);
    // Prototype rendering is inside the lobby app, which needs these params on every page
    if (is_preview && !url.searchParams.has('is_preview')) {
      url.searchParams.append('is_preview', '1');
    }
    if (project_uuid && !url.searchParams.has('project_uuid')) {
      url.searchParams.append('project_uuid', project_uuid);
    }
    if (participation_uuid && !url.searchParams.has('participation_uuid')) {
      url.searchParams.append('participation_uuid', participation_uuid);
    }
    urlToOpen = url.toString();
  }

  return enrichTestUrl(urlToOpen);
}
